/**
 * 스크롤 최상단 이동 훅
 *
 * 주요 기능:
 * - 페이지 라우트 변경 시 스크롤 위치를 최상단으로 자동 이동
 * - React Router의 pathname 변경 감지
 * - 즉시 스크롤(instant behavior) 적용
 *
 * 동작 방식:
 * - useLocation의 pathname이 변경될 때마다 useEffect 실행
 * - window.scrollTo를 사용하여 페이지 최상단으로 이동
 *
 * 사용처:
 * - Layout.tsx에서 모든 페이지 전환 시 자동 적용
 * - 페이지 간 이동 시 일관된 UX 제공
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 페이지 라우트 변경 시 스크롤을 최상단으로 이동하는 커스텀 훅
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 경로가 변경될 때마다 스크롤을 최상단으로 이동
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [pathname]);
};
